/**
 * CMCD status header name.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_STATUS = 'CMCD-Status';
